import {action} from "typesafe-actions";
import {Alias} from "@models/alias";
import {RequestData} from "@models/axios";

export const enum AliasesActionTypes {
    FETCH_REQUEST = "@@aliases/FETCH_REQUEST",
    FETCH_SUCCESS = "@@aliases/FETCH_SUCCESS",
    FETCH_ERROR = "@@aliases/FETCH_ERROR",

    DELETE_REQUEST = '@@aliases/DELETE_REQUEST',
    DELETE_SUCCESS = '@@aliases/DELETE_SUCCESS',
    DELETE_ERROR = '@@aliases/DELETE_ERROR',

    CREATE_REQUEST = '@@aliases/CREATE_REQUEST',
    CREATE_SUCCESS = '@@aliases/CREATE_SUCCESS',
    CREATE_ERROR = '@@aliases/CREATE_ERROR',

    UPDATE_REQUEST = '@@aliases/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@aliases/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@aliases/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = "@@aliases/FETCH_ITEM_REQUEST",
    FETCH_ITEM_SUCCESS = "@@aliases/FETCH_ITEM_SUCCESS",
    FETCH_ITEM_ERROR = "@@aliases/FETCH_ITEM_ERROR",

    UPDATE_PROPERTY_ITEM_REQUEST = '@@aliases/UPDATE_PROPERTY_ITEM_REQUEST',
    UPDATE_PROPERTY_ITEM_SUCCESS = '@@aliases/UPDATE_PROPERTY_ITEM_SUCCESS',
    UPDATE_PROPERTY_ITEM_ERROR = '@@aliases/PATCH_ITEM_ERROR',
}

export const fetchRequest = (data: {}) => action(AliasesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Alias[]) => action(AliasesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(AliasesActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data: RequestData) => action(AliasesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data: RequestData) => action(AliasesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(AliasesActionTypes.DELETE_ERROR, message);

export const createRequest = (data: RequestData) => action(AliasesActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: RequestData) => action(AliasesActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(AliasesActionTypes.CREATE_ERROR, message);

export const updateRequest = (data: RequestData) => action(AliasesActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: RequestData) => action(AliasesActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(AliasesActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data: RequestData) => action(AliasesActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Alias[]) => action(AliasesActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(AliasesActionTypes.FETCH_ITEM_ERROR, message);


export const updatePropertyItemRequest = (data: RequestData) => action(AliasesActionTypes.UPDATE_PROPERTY_ITEM_REQUEST, data);
export const updatePropertyItemSuccess = (data: RequestData) => action(AliasesActionTypes.UPDATE_PROPERTY_ITEM_SUCCESS, data);
export const updatePropertyItemError = (message: string) => action(AliasesActionTypes.UPDATE_PROPERTY_ITEM_ERROR, message);